export const MOBILE = 'mobile'
export const HEADER = 'header'
export const TABLET = 'tablet'
export const TABLET_PLUS = 'tablet+'
export const DESKTOP = 'desktop'
export const DESKTOP_PLUS = 'desktop+'
